/*External dependencies*/
export const Errors = {
  emailIncorrect: 'Почта туура эмес корсотулгон',
  emailFieldEmpty: 'Email field empty',
  pincodeIncorrect: 'Пинкод неправилный',
  hasAnAccount: 'Мындай аккаунт регистрацияланган',
  signInError: 'Почта же пароль туура эмес!',
  resetPasswordError: 'Что-то пошло не так',
  forgotError: 'Почта регистрация боло элек',
  pincodeError: 'Пинкод туура эмес',
  newPasswordError:'not_match_password'
};

